import { api as localizationApi } from './auto-generated/localization'

localizationApi.enhanceEndpoints({
  endpoints: {},
})

export { localizationApi }
